import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {ColorPicker} from 'shells/color-picker/color-picker';
import {FormField} from 'shells/form/form-field';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import {TextField} from 'shells/textfield/textfield';

import {confineValueToRange} from '../../../../helpers';

import {FormAlignmentSelector} from '../form-alignment-selector.js/form-alignment-selector';

import styles from '../design-form.module.css';

type Props = {
    control: Control;
    name: string;
};

export function LabelDesignForm(props: Props) {
    const fontWeightOptions = [
        {id: 'normal', name: 'Regular'},
        {id: 'bold', name: 'Bold'},
    ];

    return (
        <>
            <FormField innerId='color' label='Color'>
                <Controller
                    name={`${props.name}.color`}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => (
                        <ColorPicker
                            currentColor={field.value}
                            onSetCurrentColor={field.onChange}
                        />
                    )}
                />
            </FormField>
            <Controller
                name={`${props.name}.fontSize`}
                control={props.control}
                rules={{
                    required: true,
                    min: {
                        value: 8,
                        message: 'Headers & text can’t be smaller than 8px',
                    },
                    max: {
                        value: 96,
                        message: 'Headers & text can’t be larger than 96px',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <FormField innerId='fontSize' label='Font size' errorMessage={errorMessage}>
                            <div className={styles['number-with-unit']}>
                                <TextField
                                    {...field}
                                    type='number'
                                    inputUnit='px'
                                    selectOnFocus={true}
                                    onBlur={() => {
                                        field.onChange(confineValueToRange(field.value, 8, 96, 16));
                                    }}
                                />
                            </div>
                        </FormField>
                    );
                }}
            />
            <FormField innerId='fontWeight' label='Font weight'>
                <Controller
                    name={`${props.name}.fontWeight`}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => (
                        <SelectPickerGeneric
                            {...field}
                            valueKey='id'
                            labelKey='name'
                            options={fontWeightOptions}
                            value={fontWeightOptions.find((option) => {
                                return option.id === field.value;
                            })}
                            // @ts-expect-error
                            onChange={(value) => {
                                field.onChange(value.id);
                            }}
                        />
                    )}
                />
            </FormField>
            <FormField innerId='textAlign' label='Text position' noMargin={true}>
                <Controller
                    name={`${props.name}.textAlign`}
                    control={props.control}
                    // @ts-expect-error
                    render={({field}) => (
                        <FormAlignmentSelector
                            currentPosition={field.value}
                            onSetCurrentPosition={field.onChange}
                        />
                    )}
                />
            </FormField>
        </>
    );
}
